import type { Member } from '@vista-digital/ocapi-types/v1'
import { gtm } from '@/common/services/gtm/gtm.service'
import { CurzonDataLayer } from '@/common/services/models-gtm'

export function sendNewAccountDataLayer(member: Member) {
    const dataLayer = new NewAccountDataLayer('new_account')
    dataLayer['customer-id'] = member.id
    gtm.sendDataLayer(dataLayer)
}

class NewAccountDataLayer extends CurzonDataLayer {
    'customer-id': string
}
